module.exports = __webpack_public_path__ + "assets/img/3_1294_big.93d42d3c.jpg";